import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeRunningElafron';
const args = {};

export class ModeRunningElafron extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
